import { useEffect, useState } from "react";
import { Badge, Button, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AssignSubjectEventUnscheduledForm = ({
  Show,
  Hide,
  Title,
  activeTabName,
  getStudyFormListBasedonEventSchema,
}) => {
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState("");
  const [formList, setFormList] = useState([]);
  const [formAssignedList, setFormAssignedList] = useState([]);

  const { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const assignUnassignStudySubjectEventUnscheduledForm = async (
    type,
    formId,
    formVersion,
    formType
  ) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type === "assigne" ? "Assign" : "Unassign"
        } form on this Event!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type === "assigne" ? "Assign" : "Unassign"
        } it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(formId);

        let userData = {
          mode: StudyMode,
          studyId,
          siteId: activeTabName?.siteId,
          subjectId: activeTabName?.subjectId,
          schemaId: activeTabName?.schemaId,
          eventId: activeTabName?.eventId,
          formId,
          formVersion,
          formType,
          type,
        };

        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId =
            activeTabName?.timePointUniqueId;
        }
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId =
            activeTabName?.repeatEventId;
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId =
            activeTabName?.repeatTimePointId;
        }

        let data =
          await studyEventManagementServices.assignUnassignStudySubjectEventUnscheduledForm(
            userData
          );

        if (data?.statusCode === 200) {
          getStudyFormListBasedonEventSchema();
          getAssignedUnscheduledEventFormForSubjectEventAssign();
          getAssignedSubjectEventUnscheduledForm();
        }

        setButtonLoader("");
      }
    });
  };

  const getAssignedUnscheduledEventFormForSubjectEventAssign =
    async () => {
      setLoader(true);

      let data =
        await studyEventManagementServices.getAssignedUnscheduledEventFormForSubjectEventAssign(
          studyId,
          activeTabName?.schemaId,
          activeTabName?.eventId,
          activeTabName?.timePointUniqueId || "no"
        );

      setFormList(data?.data || []);
      setLoader(false);
    };

  const checkFormStatus = (formId, formVersion) => {
    return formAssignedList?.find(
      (item) =>
        item.formId === formId &&
        item.formVersion === formVersion
    );
  };

  useEffect(() => {
    if (activeTabName) {
      getAssignedUnscheduledEventFormForSubjectEventAssign();
    }
  }, [
    activeTabName?.schemaId,
    activeTabName?.eventId,
    activeTabName?.timePointUniqueId,
  ]);

  const getAssignedSubjectEventUnscheduledForm = async () => {
    setLoader(true)
    let userData = {
      mode: StudyMode,
      studyId,
      siteId: activeTabName?.siteId,
      subjectId: activeTabName?.subjectId,
      schemaId: activeTabName?.schemaId,
      eventId: activeTabName?.eventId,
      status: "all",
    };

    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId =
        activeTabName?.timePointUniqueId;
    }

    if (activeTabName?.repeatEventId) {
      userData.repeatEventId =
        activeTabName?.repeatEventId;
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId =
        activeTabName?.repeatTimePointId;
    }

    let data =
      await studyEventManagementServices.getAssignedSubjectEventUnscheduledForm(
        userData
      );

    setFormAssignedList(data?.data || [])
    setLoader(false);
  }
  useEffect(() => {
    getAssignedSubjectEventUnscheduledForm();
  }, [activeTabName?.schemaId,
  activeTabName?.eventId,
  activeTabName?.timePointUniqueId,
  activeTabName?.siteId,
  activeTabName?.subjectId,
  ]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div style={{ height: "calc(100vh - 76px)" }}>
          {loader ? (
            <PageLoader />
          ) : (
            formList?.map((item) => {
              const formStatus = checkFormStatus(
                item.formId,
                item.formVersion
              );

              const isAssigned = !!formStatus;
              const isNoEntry =
                formStatus?.checkDataEntry === "noEntry";

              const showUnassignButton =
                isAssigned && isNoEntry;

              const showAssignButton = !isAssigned;

              const showButton =
                showUnassignButton || showAssignButton;

              return (
                <Badge
                  key={`${item.formId}_${item.formVersion}_${item.eventId}_${item.timepointUniqueId || ""
                    }`}
                  className={`hstack justify-content-between text-dark mb-2 ${!(showButton && activeTabName?.viewType === "dataEntry") ? "p-2" : ""
                    }`}
                  bg={
                    showAssignButton ? "primary-subtle" : showUnassignButton ? "success-subtle" : "secondary-subtle"
                  }
                >
                  <small>
                    {item?.formName} (v{item.formVersion})
                  </small>

                  {(showUnassignButton && activeTabName?.viewType === "dataEntry") && (
                    <Button
                      variant="link"
                      size="sm"
                      title="Unassign Form"
                      className="p-0 text-danger"
                      style={{ textDecoration: "none" }}
                      disabled={buttonLoader}
                      onClick={() =>
                        assignUnassignStudySubjectEventUnscheduledForm(
                          "unassigne",
                          item.formId,
                          item.formVersion,
                          item.formType
                        )
                      }
                    >
                      {buttonLoader === item?.formId ? (
                        <Spinner
                          animation="border"
                          size="sm"
                        />
                      ) : (
                        "×"
                      )}
                    </Button>
                  )}

                  {(showAssignButton && activeTabName?.viewType === "dataEntry") && (
                    <Button
                      variant="link"
                      size="sm"
                      title="Assign Form"
                      className="p-0 text-primary"
                      disabled={buttonLoader}
                      onClick={() =>
                        assignUnassignStudySubjectEventUnscheduledForm(
                          "assigne",
                          item.formId,
                          item.formVersion,
                          item.formType
                        )
                      }
                    >
                      {buttonLoader === item?.formId ? (
                        <Spinner
                          animation="border"
                          size="sm"
                        />
                      ) : (
                        "+"
                      )}
                    </Button>
                  )}
                </Badge>
              );
            })
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AssignSubjectEventUnscheduledForm;